import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconUserAddRight: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconUserAddRight"><Path d="M2.5 20.5V19.5C2.5 15.3579 5.85786 12 10 12C14.1421 12 17.5 15.3579 17.5 19.5V20.5H2.5Z" stroke="currentColor"/><Circle cx="10" cy="7.5" r="4.5" stroke="currentColor"/><Path d="M20.5 8.5V14.5M23.5 11.5H17.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round"/></CentralIconBase>;
});

export default IconUserAddRight;
